import partnerClient from "../partnerClient";

export const fetchPartnerCommissions = async (params) => {
  const { data } = await partnerClient.get("/commissions", { params });
  return data?.data ?? data;
};

/**
 * The ledger paged by entry: a page never splits a source row from its corrections, so
 * every net shown is whole. Prefer this over the row-level list for display.
 */
export const fetchPartnerCommissionEntries = async (params) => {
  const { data } = await partnerClient.get("/commission-entries", { params });
  return data?.data ?? data;
};

export const fetchPartnerPayouts = async (params) => {
  const { data } = await partnerClient.get("/payouts", { params });
  return data?.data ?? data;
};

export const fetchPartnerEarningsSummary = async () => {
  const { data } = await partnerClient.get("/earnings-summary");
  return data?.data ?? data;
};
